import { OTEL_JAEGER_FIELD_REGISTRY } from './otel-jaeger-field-registry';
import { jaegerAggregationFieldWithoutKeywordSuffix, jaegerFieldToAggregationField, otelFieldToJaeger, } from './otel-field-to-jaeger.util';
/** Legacy attribute names registered for an OTEL field, if any. */
export const getOtelFieldLegacyAliases = (otelField) => {
    if (!(otelField in OTEL_JAEGER_FIELD_REGISTRY)) {
        return undefined;
    }
    const mapping = OTEL_JAEGER_FIELD_REGISTRY[otelField];
    return 'legacyAliases' in mapping ? mapping.legacyAliases : undefined;
};
const LEGACY_ALIAS_TO_OTEL_FIELD = Object.freeze(Object.entries(OTEL_JAEGER_FIELD_REGISTRY).reduce((acc, [otel, mapping]) => {
    const aliases = 'legacyAliases' in mapping ? mapping.legacyAliases : undefined;
    aliases?.forEach(alias => {
        acc[alias] = otel;
    });
    return acc;
}, {}));
/** Canonical OTEL field for a typed name, resolving registered legacy aliases (`http.status_code` → `http.response.status_code`). */
export const getCanonicalOtelField = (field) => {
    if (field in OTEL_JAEGER_FIELD_REGISTRY) {
        return field;
    }
    return LEGACY_ALIAS_TO_OTEL_FIELD[field] ?? field;
};
const legacyAliasToJaegerField = (alias) => otelFieldToJaeger(alias);
const addAggregationForms = (targets, jaegerField) => {
    const aggregationField = jaegerFieldToAggregationField(jaegerField);
    const keywordNativeField = jaegerAggregationFieldWithoutKeywordSuffix(aggregationField);
    [aggregationField, keywordNativeField].forEach(field => {
        if (field && !targets.includes(field)) {
            targets.push(field);
        }
    });
};
/**
 * Aggregation-field candidates for an OTEL group-by field, most-canonical first: the registry path
 * (keyword subfield, then keyword-native) followed by the same pair for each legacy alias. Callers
 * try candidates in order and stop at the first one that produces buckets, so accounts on current
 * instrumentation never pay for the legacy probes.
 */
export const getJaegerAggregationFieldCandidates = (otelField) => {
    const canonicalField = getCanonicalOtelField(otelField);
    const candidates = [];
    addAggregationForms(candidates, otelFieldToJaeger(canonicalField));
    getOtelFieldLegacyAliases(canonicalField)?.forEach(alias => addAggregationForms(candidates, legacyAliasToJaegerField(alias)));
    return candidates;
};
//# sourceMappingURL=spans-legacy-alias.util.js.map